import { isNil } from 'lodash';
import '../../extensions/number-currency-format';

export const convertToCamelCase = (value: string | undefined) => {
  if (!isNil(value)) {
    return value.charAt(0).toLocaleUpperCase() + value.slice(1).toLocaleLowerCase();
  }
  return undefined;
};

export const convertToCurrency = (value: string | number | Date | undefined) => {
  if (!isNil(value)) {
    return Number(value).ToCurrencyString();
  }
  return undefined;
};

export const formatToCurrency = (value: string | number | Date | undefined) => {
  if (isNil(value) || Number(value) === 0) {
    return '-';
  }
  return Number(value).ToCurrencyString();
};

export const getLabelFromFrequency = (freq?: string | null): string => {
  switch (freq) {
    case '12':
      return 'monthly';
    case '4':
      return 'quarterly';
    case '2':
      return 'half-yearly';
    case '1':
      return 'yearly';
    default:
      return '';
  }
};

export const slugify = (text: string) => {
  return text
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
};
